import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AUTH_ROUTES } from '../constants';
import FlowGuard from '../../components/FlowGuard';

const ResetSuccessContent: React.FC = () => {
    const navigate = useNavigate();

    const handleGoToSignIn = () => {
        navigate(AUTH_ROUTES.LOGIN);
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
             style={{
                 background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(116, 153, 191, 0.465385) 41.83%, rgba(237, 242, 247, 0) 100%)',
             }}>

            {/* Background Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#2563EB] to-[#1D4ED8] opacity-90"></div>

            {/* Content */}
            <div className="relative z-10 text-center text-white max-w-md mx-auto">
                {/* Logo */}
                <div className="mb-12">
                    <img
                        src="/branding/logo_blue.svg"
                        alt="Hush"
                        className="h-12 w-auto mx-auto"
                        style={{
                            filter: 'brightness(0) saturate(100%) invert(100%)'
                        }}
                    />
                </div>

                {/* Title */}
                <h1
                    style={{
                        fontFamily: 'Manrope',
                        fontWeight: 700,
                        fontSize: 'clamp(28px, 5vw, 36px)',
                        color: '#FFFFFF',
                        marginBottom: '24px',
                        lineHeight: '1.2'
                    }}
                >
                    Your password has been reset
                </h1>

                {/* Description */}
                <p
                    style={{
                        fontFamily: 'Manrope',
                        fontSize: 'clamp(14px, 2vw, 16px)',
                        color: '#BFDBFE',
                        marginBottom: '48px',
                        lineHeight: '1.6',
                        maxWidth: '400px',
                        margin: '0 auto 48px'
                    }}
                >
                    You can now use your new password to log in to your Hush account.
                </p>

                {/* Success Icon */}
                <div
                    style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '50%',
                        background: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 48px',
                        backdropFilter: 'blur(10px)'
                    }}
                >
                    <div
                        style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            background: 'rgba(16, 185, 129, 0.8)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        {/* Success checkmark with badge shape */}
                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                background: 'rgba(59, 130, 246, 0.9)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative'
                            }}
                        >
                            {/* Star-like badge background */}
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(59, 130, 246, 0.6)',
                                    borderRadius: '30%',
                                    transform: 'rotate(45deg)'
                                }}
                            />
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ position: 'relative', zIndex: 1 }}>
                                <path
                                    d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                    stroke="white"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Go to Sign In Button */}
                <button
                    onClick={handleGoToSignIn}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: 'none',
                        border: 'none',
                        color: '#BFDBFE',
                        fontSize: '16px',
                        fontFamily: 'Manrope',
                        cursor: 'pointer',
                        padding: '12px 0',
                        margin: '0 auto',
                        transition: 'color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#BFDBFE'}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19l-7-7 7-7" stroke="currentColor"/>
                    </svg>
                    Go to sign in
                </button>
            </div>
        </div>
    );
};

/**
 * ResetSuccess Page
 * Protected by FlowGuard - only accessible after password reset flow
 * Direct URL access redirects to login page
 */
const ResetSuccess: React.FC = () => {
    return (
        <FlowGuard
            requiredStateKey="fromPasswordReset"
            fallbackPath="/auth/login"
        >
            <ResetSuccessContent />
        </FlowGuard>
    );
};

export default ResetSuccess;
